import DocloudTemplate from './DocloudTemplate';

//! https://github.com/alibaba/react-intl-universal/issues/144#issuecomment-1345193138
//! All these templates here are fixed and for all the clients
export const REPORT_TEMPLATE_LIST = () => [
  {
    id: 1,
    title: 'DOCloud Template',
    template: DocloudTemplate,
  },
];
